import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 20px 0;

  @media (min-width: 992px) {
    flex-direction: row;
    gap: 16px;
  }
`;

const Card = styled.div`
  flex: ${(props) => (props.active ? "2" : "1")};
  background-image: url(${(props) => props.background});
  background-size: cover;
  background-position: center;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s ease;
  min-height: 300px;
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Shadow added here */
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);

  @media (max-width: 992px) {
    flex: 1;
    width: 100%;
    min-height: 250px;
    max-height: unset;
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.2));
    z-index: 1;
    transition: opacity 0.3s ease;
  }
`;

const CardContent = styled.div`
  position: relative;
  z-index: 2;
  color: #fff;
  text-align: center;
  padding: 20px;
  max-width: 90%;
  transition: all 0.3s ease;
  opacity: 1;
  transform: none;
`;

const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: ${(props) => (props.active ? "16px" : "0")};
  transition: color 0.3s ease;

  &:hover {
    color: #54bfcc;
  }
`;

const ContentWrapper = styled.div`
  opacity: ${(props) => (props.active ? 1 : 0)};
  max-height: ${(props) => (props.active ? "1000px" : "0")};
  overflow: hidden;
  transition: all 0.4s ease;
  margin-top: ${(props) => (props.active ? "16px" : "0")};
`;

const ContentList = styled.ul`
  list-style-type: disc;
  text-align: left;
  padding-left: 20px;
  margin: 0;
  font-size: 0.95rem;

  li {
    margin-bottom: 8px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 14px;
  z-index: 3;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  font-size: 18px;
  padding: 4px 10px;
  border-radius: 8px;
  cursor: pointer;
  display: ${(props) => (props.active ? "block" : "none")};

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 992px) {
    display: none;
  }
`;

const IndiaAIFestivalTarget = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleToggle = (index) => {
    setActiveIndex((prev) => (prev === index ? -1 : index));
  };

  const sections = [
    {
      title: t("section_1_title"),
      background: "images/what-is-impact-fest.jpg",
      content: (
        <p className="text-white">
          {t("impact_festival_2025.section_1_content")}
        </p>
      ),
    },
    {
      title: t("section_2_title"),
      background: "images/how-to-participate.JPG",
      content: (
        <ContentList>
          <li>
            <strong>{t("impact_festival_2025.section_2_subtitle_1")}</strong>{" "}
            {t("impact_festival_2025.section_2_content_1")}
          </li>
          <li>
            <strong>{t("impact_festival_2025.section_2_subtitle_2")}</strong>{" "}
            {t("impact_festival_2025.section_2_content_2")}
          </li>
          <li>
            <strong>{t("impact_festival_2025.section_2_subtitle_3")}</strong>{" "}
            {t("impact_festival_2025.section_2_content_3")}
          </li>
        </ContentList>
      ),
    },
    {
      title: t("section_3_title"),
      background: "images/why-to-participate.jpeg",
      content: (
        <ContentList>
          <li>{t("section_3_content_1")}</li>
          <li>{t("section_3_content_2")}</li>
          <li>{t("impact_festival_2025.section_3_content_3")}</li>
          <li>{t("section_3_content_4")}</li>
          <li>{t("section_3_content_5")}</li>
          <li>{t("section_3_content_6")} </li>
          <li>{t("section_3_content_7")}</li>
          <li>{t("section_3_content_8")}</li>
        </ContentList>
      ),
    },
  ];

  return (
    <div className="container">
      <SectionWrapper>
        {sections.map((section, index) => {
          const isActive = activeIndex === index;

          return (
            <Card
              key={index}
              background={section.background}
              active={isActive}
              onClick={() => handleToggle(index)}
            >
              <CloseButton
                active={isActive}
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveIndex(-1);
                }}
              >
                ×
              </CloseButton>

              <CardContent>
                <Title className="text-white" active={isActive}>
                  {section.title}
                </Title>
                <ContentWrapper active={isActive}>
                  {section.content}
                </ContentWrapper>
              </CardContent>
            </Card>
          );
        })}
      </SectionWrapper>
    </div>
  );
};

export default IndiaAIFestivalTarget;
